/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * An enumeration.
 */
export enum InvoiceLevelCategoriesEnum {
    INTAKE = 'INTAKE',
    REFERENCE = 'REFERENCE',
    DOCUMENT = 'DOCUMENT',
    RE_STATEMENT = 'RE_STATEMENT',
    SUMMARY = 'SUMMARY',
    INVOICE = 'INVOICE',
    FEE = 'FEE',
    PREVIOUS_CHARGE = 'PREVIOUS_CHARGE',
}
